module.exports = __webpack_public_path__ + "static/media/2.77a3aef3.jpg";